(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gi-barra-compra"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-barra-compra')) {
    class GiBarraCompra extends HTMLElement {
      connectedCallback() {
        // Con el banner Cyber arriba, la barra aparece recién cuando el banner sale de pantalla.
        const cta = [...document.querySelectorAll('.gi-phero__banner > a')].find((a) => a.offsetParent !== null) || document.querySelector('.gi-phero__ctas');
        let ctaVisible = true;
        // Los flotantes (visitas y videos/dudas) van siempre abajo de todo; cuando aparece la barra, suben arriba de
        // ella: la barra publica en --gi-flot-bottom dónde termina (0 = no está y vuelven al fondo).
        const actualizar = () => {
          this.hidden = ctaVisible;
          const raiz = document.documentElement.style;
          if (ctaVisible) raiz.removeProperty('--gi-flot-bottom');
          else raiz.setProperty('--gi-flot-bottom', `${this.getBoundingClientRect().height + 12 + 10}px`);
        };
        this.observador = new IntersectionObserver((entradas) => {
          for (const e of entradas) {
            // Solo cuenta como "pasado" cuando el botón quedó arriba: antes de llegar a él la barra no aparece.
            if (e.target === cta) ctaVisible = e.isIntersecting || e.boundingClientRect.top > 0;
          }
          actualizar();
        });
        // Copia el pack elegido en el banner: fotos, nombre, precio y el link del botón.
        this.copiar = () => {
          const b = [...document.querySelectorAll('.gi-phero__btn')].find((x) => x.offsetParent !== null);
          const btn = this.querySelector('[data-barra-btn]');
          // Con el banner Cyber el botón del banner está oculto: la barra va directo al pack elegido (el combo).
          const elegido = document.querySelector('.gi-packs--selector [data-pack]:has(input:checked)');
          if (!b && btn && elegido && document.querySelector('.gi-phero--cyber')) {
            btn.href = document.documentElement.classList.contains('gi-usd') ? '#comprar' : elegido.dataset.carrito;
            const t = [...btn.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
            if (t) t.textContent = 'Comprar agentes ';
          }
          if (b && btn) {
            btn.href = b.href;
            if (b.getAttribute('aria-disabled')) btn.setAttribute('aria-disabled', 'true');
            else btn.removeAttribute('aria-disabled');
          }
          const op = document.querySelector('.gi-packs--selector [data-pack]:has(input:checked)');
          if (!op) return;
          const n = op.querySelector('input')?.value;
          const nombre = this.querySelector('[data-barra-nombre]');
          // El combo Cyber (Editor de videos) va con su nombre y su chip 3x1.
          const combo = op.classList.contains('gi-packs__op--combo');
          if (nombre && n) nombre.innerHTML = n === '1' ? nombre.dataset.original || nombre.textContent : combo ? 'Combo<span class="gi-barra__chip">3x1</span>' : `${n} agentes${n === '3' ? '<span class="gi-barra__chip">3x2</span>' : ''}`;
          const fotos = this.querySelector('[data-barra-fotos]');
          if (fotos) fotos.replaceChildren(...[...op.querySelectorAll('.gi-packs__agentes img')].map((i) => i.cloneNode()));
          const precio = this.querySelector('[data-barra-precio]');
          const usd = document.documentElement.classList.contains('gi-usd');
          let visible = [...op.querySelectorAll('.gi-packs__precio > span')].find((x) => x.offsetParent !== null);
          // Con el banner Cyber el selector está oculto: se toma el precio de la moneda que corresponde.
          if (!visible && document.querySelector('.gi-phero--cyber')) {
            visible = op.querySelector(usd ? '.gi-packs__precio > .gi-solo-usd' : '.gi-packs__precio > span:not(.gi-solo-usd)');
          }
          const destino = usd ? this.querySelector('.gi-barra__precio.gi-solo-usd') || precio : precio;
          if (visible && destino) {
            const b2 = visible.querySelector('b')?.textContent || '';
            const s2 = visible.querySelector('s')?.textContent || '';
            destino.innerHTML = `${b2}${s2 ? `<s>${s2}</s>` : ''}`;
          }
        };
        const nombre = this.querySelector('[data-barra-nombre]');
        if (nombre) nombre.dataset.original = nombre.textContent;
        document.addEventListener('change', (e) => {
          if (e.target.closest('.gi-packs--selector')) setTimeout(this.copiar, 0);
        });
        setTimeout(this.copiar, 0);
        if (window.giMoneda) window.giMoneda.then(() => setTimeout(this.copiar, 50));
        window.addEventListener('load', () => this.copiar());
        if (cta) this.observador.observe(cta);
      }

      disconnectedCallback() {
        this.observador?.disconnect();
      }
    }
    customElements.define('gi-barra-compra', GiBarraCompra);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-carruseles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-carruseles-abanico')) {
    class GiCarruselesAbanico extends HTMLElement {
      connectedCallback() {
        this.controlador = new AbortController();
        const { signal } = this.controlador;
        this.cartas = [...this.querySelectorAll('[data-carta]')];
        this.total = this.cartas.length;
        this.centro = this.total >> 1;
        this.hover = null;
        this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.celu = window.matchMedia('(max-width: 639px)');
        this.celu.addEventListener('change', () => this.ubicar(), { signal });
        this.cartas.forEach((carta, i) => {
          carta.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse') return;
            if (this.hover !== i) {
              this.hover = i;
              this.ubicar();
            }
          }, { signal });
          const pista = carta.querySelector('[data-pista]');
          carta.querySelectorAll('[data-paso]').forEach((b) =>
            b.addEventListener('click', () => {
              this.ir(carta, this.actual(carta) + Number(b.dataset.paso));
              this.tocada = Date.now();
            }, { signal })
          );
          pista.addEventListener('scroll', () => this.marcar(carta), { passive: true, signal });
          pista.addEventListener('pointerdown', () => (this.tocada = Date.now()), { signal });
          pista.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              this.ir(carta, this.actual(carta) + (e.key === 'ArrowRight' ? 1 : -1));
              this.tocada = Date.now();
            }
          }, { signal });
          this.arrastre(carta, pista, signal);
          this.marcar(carta);
        });
        this.querySelector('[data-mazo]').addEventListener('mouseleave', () => {
          this.hover = null;
          this.ubicar();
        }, { signal });
        window.addEventListener('resize', () => this.ubicar(), { signal });
        this.entrada = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          this.entrada.disconnect();
          this.entro = true;
          this.ubicar(true);
        }, { threshold: 0.2 });
        this.entrada.observe(this);
        this.enPantalla = new IntersectionObserver(([e]) => {
          this.visible = e.isIntersecting;
          this.programar();
        }, { threshold: 0.35 });
        this.enPantalla.observe(this);
      }
      disconnectedCallback() {
        this.controlador?.abort();
        this.entrada?.disconnect();
        this.enPantalla?.disconnect();
        clearTimeout(this.reloj);
      }
      slides(carta) {
        return carta.querySelectorAll('.gi-post__slide').length;
      }
      actual(carta) {
        const pista = carta.querySelector('[data-pista]');
        return Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
      }
      ir(carta, i) {
        const n = this.slides(carta);
        const pista = carta.querySelector('[data-pista]');
        const destino = ((i % n) + n) % n;
        pista.scrollTo({ left: destino * pista.clientWidth, behavior: this.reducido ? 'auto' : 'smooth' });
      }
      // Contador, puntitos y flechas según la slide que se ve.
      marcar(carta) {
        const i = this.actual(carta);
        const n = this.slides(carta);
        const contador = carta.querySelector('[data-contador]');
        if (contador) contador.textContent = `${i + 1}/${n}`;
        carta.querySelectorAll('[data-puntos] i').forEach((p, j) => p.toggleAttribute('data-activo', j === i));
        const ant = carta.querySelector('[data-paso="-1"]');
        const sig = carta.querySelector('[data-paso="1"]');
        if (ant) ant.disabled = i === 0;
        if (sig) sig.disabled = i >= n - 1;
      }
      // Con el mouse también se arrastra la slide (en el celu lo hace el scroll nativo).
      arrastre(carta, pista, signal) {
        let inicio = null;
        pista.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          inicio = { x: e.clientX, i: this.actual(carta) };
        }, { signal });
        const soltar = (e) => {
          if (!inicio) return;
          const dx = e.clientX - inicio.x;
          if (Math.abs(dx) > 30) this.ir(carta, inicio.i + (dx < 0 ? 1 : -1));
          inicio = null;
        };
        pista.addEventListener('pointerup', soltar, { signal });
        pista.addEventListener('pointerleave', soltar, { signal });
        pista.addEventListener('dragstart', (e) => e.preventDefault(), { signal });
      }
      // La carta del centro pasa sola sus slides, salvo que la sección no se vea o alguien la esté usando.
      programar() {
        clearTimeout(this.reloj);
        const segundos = Number(this.dataset.pase || 0);
        if (!segundos || this.reducido || !this.visible) return;
        this.reloj = setTimeout(() => {
          const carta = this.celu.matches ? this.masVisible() : this.cartas[this.centro];
          const usada = this.hover !== null || document.hidden || Date.now() - (this.tocada || 0) < 6000;
          if (carta && !usada) this.ir(carta, this.actual(carta) + 1);
          this.programar();
        }, segundos * 1000);
      }
      // En el feed del celular: la carta que se ve entera (o la más cercana al centro de la pantalla).
      masVisible() {
        const medio = window.innerHeight / 2;
        let mejor = null;
        let dist = Infinity;
        for (const c of this.cartas) {
          const b = c.getBoundingClientRect();
          if (b.bottom < 0 || b.top > window.innerHeight) continue;
          const d = Math.abs(b.top + b.height / 2 - medio);
          if (d < dist) {
            dist = d;
            mejor = c;
          }
        }
        return mejor;
      }
      multiplicador() {
        const mazo = this.querySelector('[data-mazo]');
        const carta = this.cartas[0];
        if (!mazo || !carta) return 1;
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        const libre = mazo.clientWidth / 2 - carta.offsetWidth * 0.85;
        return Math.max(0.2, Math.min(1, libre / (17 * rem)));
      }
      config(slot) {
        const c = (this.total - 1) / 2;
        const d = c > 0 ? (slot - c) / c : 0;
        const a = Math.abs(d);
        return { rot: d * 8, scale: 1 - 0.14 * a * a, x: d * 17, y: a * a * 1.6, z: 10 - Math.round(Math.abs(slot - c)) };
      }
      ubicar(primera = false) {
        // En el celular van como feed: sin abanico (lo maneja el CSS).
        if (this.celu.matches) {
          this.cartas.forEach((c) => c.removeAttribute('style'));
          return;
        }
        if (!this.entro) return;
        const m = this.multiplicador();
        const c = (this.total - 1) / 2;
        this.cartas.forEach((carta, slot) => {
          const b = this.config(slot);
          let x = b.x * m;
          let y = b.y;
          let rot = b.rot;
          let scale = b.scale;
          let delay = 0;
          if (this.hover !== null) {
            const dist = Math.abs(slot - this.hover);
            delay = dist * 0.02;
            if (slot === this.hover) {
              y -= 1.5;
              rot = 0;
              scale = Math.max(scale, 1) * 1.04;
            } else {
              const lado = slot < this.hover ? -1 : 1;
              x += lado * (4 + 3 / dist) * m;
              rot += lado * (3 / (dist + 1));
            }
          } else if (primera) {
            delay = 0.15 + slot * 0.08;
          } else {
            delay = Math.abs(slot - c) * 0.02;
          }
          carta.style.zIndex = String(slot === this.hover ? 20 : b.z);
          carta.style.transitionDelay = this.reducido ? '0s' : `${delay}s`;
          carta.style.opacity = '1';
          carta.style.transform = `translate(${x}rem, ${y}rem) rotate(${rot}deg) scale(${scale})`;
        });
      }
    }
    customElements.define('gi-carruseles-abanico', GiCarruselesAbanico);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-combo-4"] && !Shopify.designMode) return;
  try {
    
(() => {
const raiz = document.getElementById('combo-4');
if (!raiz) return;
const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revelar = (el) => el.classList.add('c4-visto');
const vistos = raiz.querySelectorAll('[data-reveal]');
if ('IntersectionObserver' in window && !reducido) {
const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && (revelar(e.target), io.unobserve(e.target))), { threshold: 0.15 });
vistos.forEach((el) => io.observe(el));
setTimeout(() => vistos.forEach(revelar), 2500);
} else vistos.forEach(revelar);
const tipear = (p) => {
clearInterval(p._t);
const texto = p.dataset.texto || (p.dataset.texto = p.textContent);
if (reducido) return (p.textContent = texto);
let i = 0;
p.textContent = '';
p._t = setInterval(() => {
p.textContent = texto.slice(0, ++i);
if (i >= texto.length) clearInterval(p._t);
}, 22);
};
const tabs = [...raiz.querySelectorAll('[data-tab]')];
const paneles = [...raiz.querySelectorAll('[data-panel]')];
let actual = 0;
let tocado = 0;
const mostrar = (i) => {
actual = i;
tabs.forEach((t, j) => t.setAttribute('aria-selected', String(j === i)));
paneles.forEach((p, j) => (p.hidden = j !== i));
const tipeo = paneles[i]?.querySelector('[data-tipeo]');
if (tipeo) tipear(tipeo);
};
tabs.forEach((t, i) => t.addEventListener('click', () => ((tocado = Date.now()), mostrar(i))));
mostrar(0);
if (!reducido) setInterval(() => Date.now() - tocado > 15000 && !document.hidden && mostrar((actual + 1) % tabs.length), 7000);
const reloj = raiz.querySelector('[data-vence]');
if (reloj) {
const fin = new Date(reloj.dataset.vence).getTime();
const dos = (n) => String(n).padStart(2, '0');
const tic = () => {
const s = Math.max(0, Math.floor((fin - Date.now()) / 1000));
reloj.querySelector('[data-u="d"]').textContent = dos(Math.floor(s / 86400));
reloj.querySelector('[data-u="h"]').textContent = dos(Math.floor((s % 86400) / 3600));
reloj.querySelector('[data-u="m"]').textContent = dos(Math.floor((s % 3600) / 60));
reloj.querySelector('[data-u="s"]').textContent = dos(s % 60);
if (!s) reloj.hidden = true;
};
tic();
setInterval(tic, 1000);
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-combo-cuyo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const raiz = document.getElementById('combo-cuyo');
    if (!raiz) return;
    const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Aparecen al entrar en pantalla (con un respaldo por si el navegador no avisa).
    const revelar = (el) => el.classList.add('cuyo-visto');
    const vistos = raiz.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && !reducido) {
      const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && (revelar(e.target), io.unobserve(e.target))), { threshold: 0.15 });
      vistos.forEach((el) => io.observe(el));
      setTimeout(() => vistos.forEach(revelar), 2500);
    } else vistos.forEach(revelar);

    // Pedido que se escribe solo, como si lo tipearan.
    const tipear = (p) => {
      clearInterval(p._t);
      const texto = p.dataset.texto || (p.dataset.texto = p.textContent);
      if (reducido) return (p.textContent = texto);
      let i = 0;
      p.textContent = '';
      p._t = setInterval(() => {
        p.textContent = texto.slice(0, ++i);
        if (i >= texto.length) clearInterval(p._t);
      }, 22);
    };

    // Pestañas de los agentes: se elige con clic y, si nadie toca, pasan solas.
    const tabs = [...raiz.querySelectorAll('[data-tab]')];
    const paneles = [...raiz.querySelectorAll('[data-panel]')];
    let actual = 0;
    let tocado = 0;
    const mostrar = (i) => {
      actual = i;
      tabs.forEach((t, j) => t.setAttribute('aria-selected', String(j === i)));
      paneles.forEach((p, j) => (p.hidden = j !== i));
      const tipeo = paneles[i]?.querySelector('[data-tipeo]');
      if (tipeo) tipear(tipeo);
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => ((tocado = Date.now()), mostrar(i))));
    mostrar(0);
    if (!reducido) {
      setInterval(() => {
        if (Date.now() - tocado > 15000 && !document.hidden) mostrar((actual + 1) % tabs.length);
      }, 7000);
    }

    // Cuenta regresiva del precio reservado.
    const reloj = raiz.querySelector('[data-vence]');
    if (reloj) {
      const fin = new Date(reloj.dataset.vence).getTime();
      const dos = (n) => String(n).padStart(2, '0');
      const tic = () => {
        const s = Math.max(0, Math.floor((fin - Date.now()) / 1000));
        reloj.querySelector('[data-u="d"]').textContent = dos(Math.floor(s / 86400));
        reloj.querySelector('[data-u="h"]').textContent = dos(Math.floor((s % 86400) / 3600));
        reloj.querySelector('[data-u="m"]').textContent = dos(Math.floor((s % 3600) / 60));
        reloj.querySelector('[data-u="s"]').textContent = dos(s % 60);
        if (!s) reloj.hidden = true;
      };
      tic();
      setInterval(tic, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-combo-cyber"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-ccy-carrusel')) {
    // Carrusel del combo en el celular: los puntos siguen a la tarjeta que se ve y, la primera vez que aparece,
    // las tarjetas hacen un amago hacia la izquierda para que se note que se deslizan.
    customElements.define('gi-ccy-carrusel', class extends HTMLElement {
      connectedCallback() {
        const pista = this.querySelector('.gi-ccy__pasos');
        const puntos = [...this.querySelectorAll('.gi-ccy__puntos span')];
        if (!pista || !puntos.length) return;
        pista.addEventListener('scroll', () => {
          const tarjetas = [...pista.children];
          const i = tarjetas.reduce((mejor, t, k) => (Math.abs(t.offsetLeft - pista.scrollLeft - 16) < Math.abs(tarjetas[mejor].offsetLeft - pista.scrollLeft - 16) ? k : mejor), 0);
          puntos.forEach((p, k) => p.classList.toggle('is-activo', k === i));
          this.classList.remove('is-empujon');
        }, { passive: true });
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const io = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-empujon');
          io.disconnect();
        }, { threshold: 0.5 });
        io.observe(pista);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-combo-egcustom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const raiz = document.getElementById('combo-egcustom');
    if (!raiz) return;
    const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Aparecen al entrar en pantalla (con un respaldo por si el navegador no avisa).
    const revelar = (el) => el.classList.add('egc-visto');
    const vistos = raiz.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && !reducido) {
      const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && (revelar(e.target), io.unobserve(e.target))), { threshold: 0.15 });
      vistos.forEach((el) => io.observe(el));
      setTimeout(() => vistos.forEach(revelar), 2500);
    } else vistos.forEach(revelar);

    // Pedido que se escribe solo, como si lo tipearan.
    const tipear = (p) => {
      clearInterval(p._t);
      const texto = p.dataset.texto || (p.dataset.texto = p.textContent);
      if (reducido) return (p.textContent = texto);
      let i = 0;
      p.textContent = '';
      p._t = setInterval(() => {
        p.textContent = texto.slice(0, ++i);
        if (i >= texto.length) clearInterval(p._t);
      }, 22);
    };

    // Pestañas de los agentes: se elige con clic y, si nadie toca, pasan solas.
    const tabs = [...raiz.querySelectorAll('[data-tab]')];
    const paneles = [...raiz.querySelectorAll('[data-panel]')];
    let actual = 0;
    let tocado = 0;
    const mostrar = (i) => {
      actual = i;
      tabs.forEach((t, j) => t.setAttribute('aria-selected', String(j === i)));
      paneles.forEach((p, j) => (p.hidden = j !== i));
      const tipeo = paneles[i]?.querySelector('[data-tipeo]');
      if (tipeo) tipear(tipeo);
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => ((tocado = Date.now()), mostrar(i))));
    mostrar(0);
    if (!reducido) {
      setInterval(() => {
        if (Date.now() - tocado > 15000 && !document.hidden) mostrar((actual + 1) % tabs.length);
      }, 7000);
    }

    // Cuenta regresiva del precio reservado.
    const reloj = raiz.querySelector('[data-vence]');
    if (reloj) {
      const fin = new Date(reloj.dataset.vence).getTime();
      const dos = (n) => String(n).padStart(2, '0');
      const tic = () => {
        const s = Math.max(0, Math.floor((fin - Date.now()) / 1000));
        reloj.querySelector('[data-u="d"]').textContent = dos(Math.floor(s / 86400));
        reloj.querySelector('[data-u="h"]').textContent = dos(Math.floor((s % 86400) / 3600));
        reloj.querySelector('[data-u="m"]').textContent = dos(Math.floor((s % 3600) / 60));
        reloj.querySelector('[data-u="s"]').textContent = dos(s % 60);
        if (!s) reloj.hidden = true;
      };
      tic();
      setInterval(tic, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-cuenta-regresiva"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-cuenta-regresiva')) {
    class GiCuentaRegresiva extends HTMLElement {
      connectedCallback() {
        this.fin = Date.parse(this.dataset.fin);
        this.unidades = Object.fromEntries([...this.querySelectorAll('[data-u]')].map((el) => [el.dataset.u, el]));
        if (Number.isNaN(this.fin)) {
          this.hidden = true;
          this.publicarAlto();
          return;
        }
        // El encabezado fijo se ubica debajo de la barra: se le avisa el alto cada vez que cambia (celular, resize).
        this.medidor = new ResizeObserver(() => this.publicarAlto());
        this.medidor.observe(this);
        this.publicarAlto();
        this.tic();
        this.intervalo = setInterval(() => this.tic(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.intervalo);
        this.medidor?.disconnect();
      }

      publicarAlto() {
        document.documentElement.style.setProperty('--gi-cr-h', this.hidden ? '0px' : `${this.offsetHeight}px`);
      }

      tic() {
        const resta = this.fin - Date.now();
        if (resta <= 0) {
          clearInterval(this.intervalo);
          this.hidden = true;
          this.publicarAlto();
          return;
        }
        const s = Math.floor(resta / 1000);
        const partes = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        for (const [u, el] of Object.entries(this.unidades)) el.textContent = String(partes[u]).padStart(2, '0');
        // Un golpe en la caja de los segundos en cada tic.
        const seg = this.unidades.s?.parentElement;
        if (seg) {
          seg.classList.remove('gi-cr__caja--tic');
          void seg.offsetWidth;
          seg.classList.add('gi-cr__caja--tic');
        }
      }
    }
    customElements.define('gi-cuenta-regresiva', GiCuentaRegresiva);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-ejemplos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-ejemplos')) {
    class GiEjemplos extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('dialog');
        this.querySelector('[data-abrir]')?.addEventListener('click', () => this.abrir());
        this.querySelector('[data-cerrar]')?.addEventListener('click', () => this.panel.close());
        // Clic afuera del panel (en el fondo oscuro) lo cierra.
        this.panel.addEventListener('click', (e) => {
          if (e.target === this.panel) this.panel.close();
        });
        this.panel.addEventListener('close', () => this.pausar());
        this.iniciarBot();
        this.querySelectorAll('[data-tab]').forEach((t) =>
          t.addEventListener('click', () => {
            this.querySelectorAll('[data-tab]').forEach((x) => x.setAttribute('aria-selected', String(x === t)));
            this.querySelectorAll('[data-vista]').forEach((v) => (v.hidden = v.dataset.vista !== t.dataset.tab));
            if (t.dataset.tab !== 'ejemplos') this.pausar();
            else
              this.querySelectorAll('[data-video]').forEach((b) => {
                this.visor?.unobserve(b);
                this.visor?.observe(b);
              });
          })
        );
        // Los videos arrancan solos y sin sonido mientras se ven en el panel. Un toque les pone sonido
        // (y silencia los demás); otro toque lo pausa.
        const cuerpo = this.querySelector('.gi-ej__cuerpo');
        this.visor = new IntersectionObserver(
          (entradas) => {
            for (const e of entradas) {
              const v = e.target.querySelector('video');
              if (!v) continue;
              if (e.isIntersecting && this.panel.open) {
                if (v.dataset.pausado !== '1') {
                  v.preload = 'auto';
                  v.play().catch(() => {});
                }
              } else if (!v.paused) {
                v.pause();
              }
            }
          },
          { root: cuerpo, threshold: 0.4 }
        );
        this.querySelectorAll('[data-video]').forEach((b) => {
          this.visor.observe(b);
          const v = b.querySelector('video');
          v.addEventListener('play', () => b.classList.add('is-play'));
          v.addEventListener('pause', () => b.classList.remove('is-play'));
          b.addEventListener('click', () => {
            if (v.paused) {
              v.dataset.pausado = '';
              v.play().catch(() => {});
            } else if (v.muted) {
              this.querySelectorAll('[data-video] video').forEach((x) => (x.muted = true));
              v.muted = false;
              b.classList.add('con-sonido');
            } else {
              v.pause();
              v.dataset.pausado = '1';
            }
          });
        });
      }
      // Asistente de dudas: compara la pregunta con las preguntas de la lista (palabras en común,
      // sin tildes) y responde con la respuesta de la que más coincide. Si ninguna coincide, deriva a WhatsApp.
      iniciarBot() {
        const bot = this.querySelector('[data-bot]');
        if (!bot) return;
        const chat = bot.querySelector('[data-chat]');
        const input = bot.querySelector('[data-input]');
        const limpiar = (t) =>
          t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9ñ ]/g, ' ');
        const vacias = new Set('de la el los las un una y o que en a al del por para con como se me mi lo le es son hay tengo puedo puede si no mas muy esto eso esta este cual cuanto cuantos cuantas donde cuando quiero sirve hace tu su sus te ya'.split(' '));
        const raiz = (w) => w.replace(/(ciones|cion|mente|ando|iendo|ar|er|ir|as|os|es|a|o|s)$/, '');
        const palabras = (t) => limpiar(t).split(/\s+/).filter((w) => w.length > 2 && !vacias.has(w)).map(raiz);
        const dudas = [...this.querySelectorAll('[data-duda]')].map((d) => ({
          pregunta: d.querySelector('summary').textContent.trim(),
          html: d.querySelector('.gi-ej__resp').innerHTML,
          fuerte: new Set(palabras(d.querySelector('summary').textContent + ' ' + (d.dataset.palabras || ''))),
          debil: new Set(palabras(d.querySelector('.gi-ej__resp').textContent)),
        }));
        const agregar = (clase, contenido) => {
          const m = document.createElement('div');
          m.className = `gi-bot__msg gi-bot__msg--${clase}`;
          if (clase === 'bot') m.innerHTML = '<span class="gi-bot__avatar" aria-hidden="true">GI</span>';
          const b = document.createElement(clase === 'yo' ? 'p' : 'div');
          if (clase === 'yo') b.textContent = contenido;
          else {
            b.className = 'gi-bot__burbuja';
            b.innerHTML = contenido;
          }
          m.appendChild(b);
          chat.appendChild(m);
          chat.scrollTop = chat.scrollHeight;
          return b;
        };
        const responder = (texto) => {
          texto = texto.trim();
          if (!texto) return;
          agregar('yo', texto);
          const p = palabras(texto);
          let mejor = null;
          let puntos = 0;
          for (const d of dudas) {
            let n = 0;
            for (const w of p) n += d.fuerte.has(w) ? 3 : d.debil.has(w) ? 1 : 0;
            if (n > puntos) {
              puntos = n;
              mejor = d;
            }
          }
          const escribiendo = agregar('bot', '<span class="gi-bot__escribe"><i></i><i></i><i></i></span>');
          setTimeout(() => {
            if (mejor && puntos >= 3) {
              escribiendo.innerHTML = `<p><b>${mejor.pregunta}</b></p>${mejor.html}`;
            } else {
              const wa = bot.dataset.wa;
              const msg = encodeURIComponent(`Hola, tengo una duda sobre ${bot.dataset.producto}: ${texto}`);
              escribiendo.innerHTML = wa
                ? `<p>Esa no la tengo respondida acá. Escribinos por WhatsApp y te contesta una persona del equipo.</p><a class="gi-bot__wa" href="https://wa.me/${wa}?text=${msg}" target="_blank" rel="noopener">Seguir por WhatsApp</a>`
                : '<p>Esa no la tengo respondida acá. Escribinos desde la página de contacto y te contesta una persona del equipo.</p><a class="gi-bot__wa" href="/pages/contact">Ir a contacto</a>';
            }
            chat.scrollTop = chat.scrollHeight;
          }, 650);
        };
        bot.querySelector('[data-form]').addEventListener('submit', (e) => {
          e.preventDefault();
          responder(input.value);
          input.value = '';
        });
        bot.querySelectorAll('[data-chip]').forEach((c) => c.addEventListener('click', () => responder(c.textContent)));
      }
      abrir() {
        // El botón de compra lleva al mismo checkout que el botón del banner (con el pack elegido).
        const b = [...document.querySelectorAll('.gi-phero__btn')].find((x) => x.offsetParent !== null);
        const c = this.querySelector('[data-comprar]');
        if (b && c) {
          c.href = b.href;
          const precio = b.querySelector('strong')?.textContent;
          const texto = [...b.childNodes].find((t) => t.nodeType === 3 && t.textContent.trim())?.textContent.replace('·', '').trim();
          if (precio) c.innerHTML = `${texto || 'Comprar'} · ${precio} <span aria-hidden="true">→</span>`;
        }
        this.panel.showModal();
        // Al abrir, vuelve a mirar qué videos se ven para que arranquen solos.
        this.querySelectorAll('[data-video]').forEach((b) => {
          this.visor?.unobserve(b);
          this.visor?.observe(b);
        });
      }
      pausar() {
        this.querySelectorAll('[data-video]').forEach((b) => {
          const v = b.querySelector('video');
          if (v) {
            v.pause();
            v.muted = true;
          }
          b.classList.remove('is-play', 'con-sonido');
        });
      }
    }
    customElements.define('gi-ejemplos', GiEjemplos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-hero-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-palabras')) {
    // Cambia la palabra activa cada 2 segundos: la actual sale hacia arriba y la siguiente entra desde abajo.
    class GiPalabras extends HTMLElement {
      connectedCallback() {
        this.palabras = [...this.querySelectorAll('.gi-hv__palabra')];
        const video = this.closest('.gi-hv')?.querySelector('video');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video?.pause();
          return;
        }
        if (this.palabras.length < 2) return;
        this.i = 0;
        this.reloj = setInterval(() => this.siguiente(), 1400);
      }
      disconnectedCallback() {
        clearInterval(this.reloj);
      }
      siguiente() {
        const actual = this.palabras[this.i];
        this.i = (this.i + 1) % this.palabras.length;
        const nueva = this.palabras[this.i];
        actual.removeAttribute('data-activa');
        actual.setAttribute('data-sale', '');
        // La que vuelve a entrar arranca abajo, sin animar el viaje de arriba a abajo.
        nueva.style.transition = 'none';
        nueva.removeAttribute('data-sale');
        nueva.getBoundingClientRect();
        nueva.style.transition = '';
        nueva.setAttribute('data-activa', '');
        setTimeout(() => {
          actual.style.transition = 'none';
          actual.removeAttribute('data-sale');
          actual.getBoundingClientRect();
          actual.style.transition = '';
        }, 650);
      }
    }
    customElements.define('gi-palabras', GiPalabras);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-pedido')) {
    // Escribe solo, letra por letra, ejemplos de pedidos en la caja mientras la persona no escribe.
    class GiPedido extends HTMLElement {
      connectedCallback() {
        let ejemplos = [];
        try {
          ejemplos = JSON.parse(this.dataset.ejemplos || '[]').map((e) => e.trim()).filter(Boolean);
        } catch (e) {}
        this.texto = this.querySelector('[data-texto]');
        if (!this.texto || !ejemplos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let i = 0;
        let letra = 0;
        let borrando = false;
        const paso = () => {
          if (document.activeElement === this.texto || this.texto.value) {
            this.reloj = setTimeout(paso, 600);
            return;
          }
          const ej = ejemplos[i % ejemplos.length];
          letra += borrando ? -2 : 1;
          this.texto.placeholder = ej.slice(0, Math.max(0, letra)) + (borrando ? '' : '|');
          let espera = borrando ? 18 : 38;
          if (!borrando && letra >= ej.length) {
            borrando = true;
            espera = 1800;
          } else if (borrando && letra <= 0) {
            borrando = false;
            i++;
            espera = 300;
          }
          this.reloj = setTimeout(paso, espera);
        };
        this.reloj = setTimeout(paso, 800);
      }
      disconnectedCallback() {
        clearTimeout(this.reloj);
      }
    }
    customElements.define('gi-pedido', GiPedido);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-landing-editor"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const listo = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
    listo(() => {
      const raices = document.querySelectorAll('[data-lpe]');
      if (!raices.length) return;
      document.documentElement.setAttribute('data-lpe-js', '');
      const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Aparecen al entrar en pantalla, una sola vez (con respaldo por si el navegador no avisa).
      const revelar = (el) => {
        el.classList.add('lpe-visto');
        if (el.matches('[data-lpe-chat]')) responder(el);
        if (el.matches('[data-lpe-filas]')) prenderSwitch();
      };
      const aparecen = document.querySelectorAll('[data-lpe-rev], [data-lpe-filas]');
      if ('IntersectionObserver' in window && !reducido) {
        const io = new IntersectionObserver(
          (es) => es.forEach((e) => e.isIntersecting && (revelar(e.target), io.unobserve(e.target))),
          { threshold: 0.2 }
        );
        aparecen.forEach((el) => io.observe(el));
      } else aparecen.forEach(revelar);

      // Problema: el interruptor da vuelta las filas; si nadie lo toca, se prende solo al rato de verlas.
      const sw = document.querySelector('[data-lpe-switch]');
      const filas = document.querySelector('[data-lpe-filas]');
      let tocado = false;
      const ponerSwitch = (on) => {
        if (!sw || !filas) return;
        sw.setAttribute('aria-pressed', String(on));
        filas.classList.toggle('lpe-con', on);
      };
      sw?.addEventListener('click', () => {
        tocado = true;
        ponerSwitch(sw.getAttribute('aria-pressed') !== 'true');
      });
      function prenderSwitch() {
        setTimeout(() => !tocado && ponerSwitch(true), 1600);
      }

      // Chat de "cómo funciona": se tipea el pedido y después aparecen los pasos del agente.
      function responder(chat) {
        const p = chat.querySelector('[data-lpe-tipeo]');
        if (!p || chat.dataset.hecho) return;
        chat.dataset.hecho = '1';
        const texto = p.textContent;
        if (reducido) return chat.classList.add('lpe-respondio');
        p.textContent = '';
        let i = 0;
        const t = setInterval(() => {
          p.textContent = texto.slice(0, ++i);
          if (i >= texto.length) {
            clearInterval(t);
            setTimeout(() => chat.classList.add('lpe-respondio'), 350);
          }
        }, 24);
      }

      // Videos: se cargan y reproducen sólo cuando se ven (mudos); con un toque se escuchan.
      const todos = [];
      const mutearOtros = (menos) =>
        todos.forEach((x) => {
          if (x.video !== menos) {
            x.video.muted = true;
            x.boton?.setAttribute('aria-pressed', 'false');
          }
        });
      const verVideos = new IntersectionObserver(
        (es) =>
          es.forEach((e) => {
            const vid = e.target;
            if (e.isIntersecting) {
              if (vid.preload === 'none') vid.preload = 'auto';
              vid.play().catch(() => {});
            } else vid.pause();
          }),
        { threshold: 0.35 }
      );
      const registrar = (video, boton) => {
        todos.push({ video, boton });
        verVideos.observe(video);
        boton?.addEventListener('click', () => {
          const prender = video.muted;
          mutearOtros(video);
          video.muted = !prender;
          boton.setAttribute('aria-pressed', String(prender));
          if (prender) {
            video.play().catch(() => {});
          }
        });
      };

      // Hero: antes y después, con chips para cambiar de marca.
      const pares = document.querySelector('lpe-pares');
      if (pares) {
        const crudo = pares.querySelector('[data-lpe-crudo]');
        const editado = pares.querySelector('[data-lpe-editado]');
        const sonido = pares.querySelector('[data-lpe-sonido]');
        const texto = pares.querySelector('[data-lpe-texto]');
        registrar(editado, sonido);
        verVideos.observe(crudo);
        const cambiar = (vid, src, poster) => {
          vid.poster = poster;
          vid.querySelector('source').src = src;
          vid.load();
          vid.play().catch(() => {});
        };
        pares.querySelectorAll('[data-crudo]').forEach((b) =>
          b.addEventListener('click', () => {
            pares.querySelectorAll('[data-crudo]').forEach((x) => x.setAttribute('aria-selected', String(x === b)));
            cambiar(crudo, b.dataset.crudo, b.dataset.crudoPoster);
            cambiar(editado, b.dataset.editado, b.dataset.editadoPoster);
            if (texto) texto.textContent = b.dataset.texto;
          })
        );
      }

      // Videos de marcas reales: tocar uno lo escucha; las flechas corren la tira.
      const rail = document.querySelector('lpe-rail');
      if (rail) {
        rail.querySelectorAll('.lpe-rail__item').forEach((b) => registrar(b.querySelector('video'), b));
        document.querySelectorAll('[data-lpe-mover]').forEach((f) =>
          f.addEventListener('click', () => {
            const paso = rail.querySelector('.lpe-rail__item')?.offsetWidth || 260;
            rail.scrollBy({ left: Number(f.dataset.lpeMover) * (paso + 18) * 2, behavior: reducido ? 'auto' : 'smooth' });
          })
        );
      }

      // Implementación asistida: cambia el link del botón y el total.
      const impl = document.querySelector('[data-lpe-impl]');
      const comprar = document.querySelector('[data-lpe-comprar]');
      if (impl && comprar) {
        const total = document.querySelector('[data-lpe-total]');
        const cuota = document.querySelector('[data-lpe-cuota]');
        impl.addEventListener('change', () => {
          const con = impl.checked;
          comprar.href = con ? comprar.dataset.con : comprar.dataset.solo;
          if (total) total.textContent = con ? comprar.dataset.totalCon : comprar.dataset.totalSolo;
          if (cuota) cuota.textContent = con ? comprar.dataset.cuotaCon : comprar.dataset.cuotaSolo;
        });
      }

      // Barra fija del celular: aparece cuando el botón del hero sale de pantalla y se va cuando hay otro precio a la vista.
      const barra = document.querySelector('[data-lpe-barra]');
      if (barra && 'IntersectionObserver' in window) {
        const vistos = new Set();
        const mirar = document.querySelectorAll('[data-lpe-cta], [data-lpe-precio]');
        const io = new IntersectionObserver(
          (es) => {
            es.forEach((e) => (e.isIntersecting ? vistos.add(e.target) : vistos.delete(e.target)));
            const heroCta = mirar[0];
            const ver = vistos.size === 0 && heroCta && heroCta.getBoundingClientRect().bottom < 0;
            barra.classList.toggle('lpe-barra--ver', ver);
            barra.setAttribute('aria-hidden', String(!ver));
            barra.querySelector('a')?.setAttribute('tabindex', ver ? '0' : '-1');
          },
          { threshold: 0 }
        );
        mirar.forEach((el) => io.observe(el));
      }

      // Ícono flotante: con el mouse gira hacia el puntero (en el celular y con "reducir movimiento" sólo flota).
      document.querySelectorAll('lpe-flota').forEach((f) => {
        if (reducido || !window.matchMedia('(hover: hover)').matches) return;
        f.addEventListener('pointermove', (e) => {
          const r = f.getBoundingClientRect();
          f.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5) * 2);
          f.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5) * 2);
          f.setAttribute('data-activo', '');
        });
        f.addEventListener('pointerleave', () => {
          f.style.setProperty('--mx', 0);
          f.style.setProperty('--my', 0);
          f.removeAttribute('data-activo');
        });
      });

      // La línea que recorre los cuadros llega hasta el último.
      document.querySelectorAll('.lpe-cuadros').forEach((c) => c.style.setProperty('--lpe-scan-x', `${c.offsetWidth}px`));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-menu-agentes"]) return;
  try {
    
  if (!customElements.get('gi-menu-agentes')) {
    // Pone el panel de logos debajo de cada link "Agentes" del menú (computadora y celular).
    class GiMenuAgentes extends HTMLElement {
      connectedCallback() {
        // Se espera a que la página termine de cargar: antes, el template y el menú pueden no estar.
        const poner = () => {
          const ruta = this.dataset.coleccion;
          const tpl = this.querySelector('template');
          if (!ruta || !tpl) return;
          document.querySelectorAll(`header a[href="${ruta}"]`).forEach((a) => {
            const li = a.closest('li');
            if (!li || li.dataset.giMa) return;
            li.dataset.giMa = '1';
            const panel = tpl.content.firstElementChild.cloneNode(true);
            // Menú del celular: sin logos, solo las opciones.
            if (li.closest('.menu-drawer, [class*="drawer"]')) return;
            // Computadora: el menú recorta lo que sobresale, así que el panel va en el body,
            // fijo debajo del link, y se abre al pasar el mouse o con el teclado.
            panel.classList.add('gi-ma--flota');
            document.body.appendChild(panel);
            let cierre;
            const abrir = () => {
              clearTimeout(cierre);
              const r = a.getBoundingClientRect();
              panel.style.left = Math.max(12, r.left - 16) + 'px';
              panel.style.top = r.bottom + 14 + 'px';
              panel.classList.add('is-abierto');
            };
            const cerrar = () => {
              cierre = setTimeout(() => panel.classList.remove('is-abierto'), 160);
            };
            [li, panel].forEach((el) => {
              el.addEventListener('mouseenter', abrir);
              el.addEventListener('mouseleave', cerrar);
              el.addEventListener('focusin', abrir);
              el.addEventListener('focusout', cerrar);
            });
            window.addEventListener('scroll', () => panel.classList.remove('is-abierto'), { passive: true, capture: true });
          });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poner);
        else requestAnimationFrame(poner);
        window.addEventListener('load', poner);
        // El menú se vuelve a armar solo (por ejemplo, cuando pasa ítems a "Más"): se vuelve a poner.
        let espera;
        new MutationObserver(() => {
          clearTimeout(espera);
          espera = setTimeout(poner, 150);
        }).observe(document.querySelector('header') || document.body, { childList: true, subtree: true });
      }
    }
    customElements.define('gi-menu-agentes', GiMenuAgentes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-planes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-planes')) {
    // Al aparecer en pantalla: el título entra palabra por palabra, las tarjetas aparecen de a una y
    // los precios suben desde cero hasta el valor real.
    class GiPlanes extends HTMLElement {
      connectedCallback() {
        const titulo = this.querySelector('[data-revelar-palabras]');
        if (titulo && !titulo.dataset.listo) {
          titulo.dataset.listo = '1';
          const texto = titulo.textContent.trim();
          titulo.setAttribute('aria-label', texto);
          titulo.innerHTML = texto
            .split(/\s+/)
            .map((w, i) => `<span class="gi-pl__palabra" aria-hidden="true"><span style="--i:${i}">${w.replace(/</g, '&lt;')}</span></span>`)
            .join(' ');
        }
        const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.observador = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          this.observador.disconnect();
          this.setAttribute('data-visto', '');
          if (!reducido) this.contar();
        }, { threshold: 0.15 });
        this.observador.observe(this);
      }
      disconnectedCallback() {
        this.observador?.disconnect();
      }
      contar() {
        this.querySelectorAll('[data-contar]').forEach((el) => {
          const fin = Number(el.dataset.contar) || 0;
          const usd = el.dataset.formato === 'usd';
          const formato = (n) => (usd ? 'USD ' : '$') + Math.round(n).toLocaleString('es-AR');
          const final = el.textContent;
          const inicio = performance.now();
          const dur = 1100;
          const paso = (t) => {
            const p = Math.min(1, (t - inicio) / dur);
            const suave = 1 - Math.pow(1 - p, 3);
            el.textContent = p < 1 ? formato(fin * suave) : final;
            if (p < 1) requestAnimationFrame(paso);
          };
          requestAnimationFrame(paso);
        });
      }
    }
    customElements.define('gi-planes', GiPlanes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-popup')) {
    class GiPopup extends HTMLElement {
      connectedCallback() {
        this.dialogo = this.querySelector('dialog');
        if (!this.dialogo) return;
        this.controlador = new AbortController();
        const { signal } = this.controlador;

        this.querySelectorAll('[data-cerrar]').forEach((b) => b.addEventListener('click', () => this.cerrar(), { signal }));
        // Tocar afuera de la tarjeta (en el fondo) cierra.
        this.dialogo.addEventListener('click', (e) => {
          if (e.target === this.dialogo) this.cerrar();
        }, { signal });
        this.dialogo.addEventListener('close', () => {
          clearInterval(this.intervaloReloj);
          this.recordar();
        }, { signal });
        this.querySelector('[data-copiar]')?.addEventListener('click', (e) => this.copiar(e.currentTarget), { signal });

        if (this.hasAttribute('data-editor')) {
          this.abrir();
          return;
        }
        if (this.yaSeVio()) return;
        const espera = Number(this.dataset.espera || 8) * 1000;
        this.temporizador = setTimeout(() => this.abrir(), espera);
        // Intención de salida: el mouse sale por arriba de la ventana.
        document.addEventListener('mouseout', (e) => {
          if (!e.relatedTarget && e.clientY <= 0) this.abrir();
        }, { signal });
      }

      disconnectedCallback() {
        this.controlador?.abort();
        clearTimeout(this.temporizador);
        clearInterval(this.intervaloReloj);
      }

      yaSeVio() {
        try {
          const hasta = Number(localStorage.getItem(this.dataset.clave) || 0);
          return hasta > Date.now();
        } catch (e) {
          return false;
        }
      }

      recordar() {
        if (this.hasAttribute('data-editor')) return;
        try {
          const dias = Number(this.dataset.dias || 3);
          localStorage.setItem(this.dataset.clave, String(Date.now() + dias * 86400000));
        } catch (e) {}
      }

      // Reloj chico con la misma fecha de fin que la cuenta regresiva del encabezado.
      arrancarReloj() {
        const reloj = this.querySelector('[data-reloj]');
        const texto = this.querySelector('[data-reloj-texto]');
        const fin = Date.parse(document.querySelector('gi-cuenta-regresiva')?.dataset.fin || '');
        if (!reloj || !texto || Number.isNaN(fin)) return;
        const tic = () => {
          const s = Math.floor((fin - Date.now()) / 1000);
          if (s <= 0) {
            reloj.hidden = true;
            clearInterval(this.intervaloReloj);
            return;
          }
          const d = Math.floor(s / 86400);
          const h = String(Math.floor((s % 86400) / 3600)).padStart(2, '0');
          const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
          const sg = String(s % 60).padStart(2, '0');
          texto.textContent = `${d}d ${h}h ${m}m ${sg}s`;
          reloj.hidden = false;
        };
        tic();
        clearInterval(this.intervaloReloj);
        this.intervaloReloj = setInterval(tic, 1000);
      }

      abrir() {
        clearTimeout(this.temporizador);
        if (this.dialogo.open || (!this.hasAttribute('data-editor') && this.yaSeVio())) return;
        // Escondido para esta persona (por ejemplo, oferta solo en pesos y está viendo dólares).
        if (getComputedStyle(this).display === 'none') return;
        // Mientras el cuestionario de bienvenida está activo, la oferta no compite con él.
        if (document.documentElement.hasAttribute('data-gi-quiz')) return;
        if (document.querySelector('dialog[open]')) return;
        this.dialogo.showModal();
        this.arrancarReloj();
      }

      cerrar() {
        this.dialogo.close();
      }

      async copiar(boton) {
        const codigo = this.querySelector('[data-codigo]')?.textContent.trim();
        if (!codigo) return;
        try {
          await navigator.clipboard.writeText(codigo);
          const antes = boton.textContent;
          boton.textContent = boton.dataset.hecho || '✓';
          setTimeout(() => (boton.textContent = antes), 2000);
        } catch (e) {}
      }
    }
    customElements.define('gi-popup', GiPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-problemas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-problemas')) {
    // Las filas aparecen de a una cuando la tabla entra en pantalla.
    class GiProblemas extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.setAttribute('data-animar', '');
        this.observador = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          this.setAttribute('data-visible', '');
          this.observador.disconnect();
        }, { threshold: 0.15 });
        this.observador.observe(this);
      }

      disconnectedCallback() {
        this.observador?.disconnect();
      }
    }
    customElements.define('gi-problemas', GiProblemas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-producto-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-tarjeta-3d')) {
    const limitar = (v) => Math.max(-1, Math.min(1, v));

    // La caja gira con el mouse (computadora), con el dedo (al deslizar sobre ella) y al inclinar
    // el teléfono (giroscopio). En iPhone el giroscopio pide permiso: se pide la primera vez que
    // la persona toca la caja. Con "reducir movimiento" queda quieta.
    class GiTarjeta3d extends HTMLElement {
      connectedCallback() {
        this.controlador = new AbortController();
        const { signal } = this.controlador;
        this.tarjeta = this.querySelector('[data-tarjeta]');
        if (!this.tarjeta || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          // Se sigue el mouse en toda la zona del producto (con el brillo), no solo sobre la foto.
          this.addEventListener('mousemove', (e) => this.inclinarDesde(e.clientX, e.clientY), { signal });
          this.addEventListener('mouseleave', () => this.soltar(), { signal });
          return;
        }

        // Dedo: mientras desliza sobre la caja, gira hacia donde está el dedo. No frena el scroll.
        this.addEventListener('touchstart', (e) => {
          this.tocando = true;
          this.pedirGiroscopio();
          const t = e.touches[0];
          if (t) this.inclinarDesde(t.clientX, t.clientY);
        }, { signal, passive: true });
        this.addEventListener('touchmove', (e) => {
          const t = e.touches[0];
          if (t) this.inclinarDesde(t.clientX, t.clientY);
        }, { signal, passive: true });
        const fin = () => {
          this.tocando = false;
          this.soltar();
        };
        this.addEventListener('touchend', fin, { signal, passive: true });
        this.addEventListener('touchcancel', fin, { signal, passive: true });

        // Giroscopio: solo mientras la caja se ve en pantalla.
        this.visible = false;
        this.observador = new IntersectionObserver(([e]) => {
          this.visible = e.isIntersecting;
          if (!this.visible && !this.tocando) this.soltar();
        });
        this.observador.observe(this);
        // Se escucha siempre; en los navegadores que piden permiso (iPhone) los datos llegan recién
        // cuando la persona lo acepta al tocar la caja.
        this.escucharGiroscopio();
      }

      disconnectedCallback() {
        this.controlador?.abort();
        this.observador?.disconnect();
        cancelAnimationFrame(this.cuadro);
      }

      inclinarDesde(x, y) {
        const r = this.getBoundingClientRect();
        this.inclinar(limitar((x - r.left - r.width / 2) / (r.width / 2)), limitar((y - r.top - r.height / 2) / (r.height / 2)), true);
      }

      inclinar(mx, my, activo) {
        this.style.setProperty('--gi-t3d-mx', mx.toFixed(3));
        this.style.setProperty('--gi-t3d-my', my.toFixed(3));
        // La luz entra por el lado contrario al giro, como un reflejo real.
        this.style.setProperty('--gi-t3d-gx', `${(50 - mx * 45).toFixed(1)}%`);
        this.style.setProperty('--gi-t3d-gy', `${(45 - my * 40).toFixed(1)}%`);
        this.toggleAttribute('data-activo', activo);
        const escala = activo ? 1.08 : 1.03;
        this.tarjeta.style.transition = activo ? 'transform 0.3s ease-out' : 'transform 0.2s linear';
        this.tarjeta.style.transform = `rotateX(${(my * -18).toFixed(2)}deg) rotateY(${(mx * 30).toFixed(2)}deg) translateZ(40px) scale(${escala})`;
      }

      soltar() {
        ['--gi-t3d-mx', '--gi-t3d-my', '--gi-t3d-gx', '--gi-t3d-gy'].forEach((v) => this.style.removeProperty(v));
        this.removeAttribute('data-activo');
        this.tarjeta.style.transition = '';
        this.tarjeta.style.transform = '';
      }

      async pedirGiroscopio() {
        if (this.permisoPedido || this.giroLlego || typeof DeviceOrientationEvent === 'undefined') return;
        if (typeof DeviceOrientationEvent.requestPermission !== 'function') return;
        this.permisoPedido = true;
        try {
          await DeviceOrientationEvent.requestPermission();
        } catch (e) {}
      }

      escucharGiroscopio() {
        if (this.giroscopio || !('DeviceOrientationEvent' in window)) return;
        this.giroscopio = true;
        this.base = null;
        window.addEventListener('deviceorientation', (e) => {
          if (e.gamma == null || e.beta == null) return;
          this.giroLlego = true;
          // La posición en que la persona sostiene el teléfono es el "centro"; se reacomoda despacio.
          if (!this.base) this.base = { g: e.gamma, b: e.beta };
          this.base.g += (e.gamma - this.base.g) * 0.01;
          this.base.b += (e.beta - this.base.b) * 0.01;
          this.giro = { mx: limitar((e.gamma - this.base.g) / 20), my: limitar((e.beta - this.base.b) / 20) };
          if (!this.cuadro) {
            this.cuadro = requestAnimationFrame(() => {
              this.cuadro = 0;
              if (this.visible && !this.tocando && this.giro) this.inclinar(this.giro.mx, this.giro.my, false);
            });
          }
        }, { signal: this.controlador.signal });
      }
    }
    customElements.define('gi-tarjeta-3d', GiTarjeta3d);
  }
  // Banner Cyber: mientras se ve el banner o algún precio con su botón (el cierre del combo, el de "Todo lo que te
  // cuesta" y la tarjeta de precio), <html data-gi-cyb-vista> esconde los flotantes que los taparían.
  if (!customElements.get('gi-cyb-banner')) {
    customElements.define('gi-cyb-banner', class extends HTMLElement {
      connectedCallback() {
        const vistos = new Set();
        this.observador = new IntersectionObserver((entradas) => {
          for (const e of entradas) {
            if (e.isIntersecting) vistos.add(e.target);
            else vistos.delete(e.target);
          }
          document.documentElement.toggleAttribute('data-gi-cyb-vista', vistos.size > 0);
        });
        this.observador.observe(this);
        const precios = () => document.querySelectorAll('.gi-ccy__cierre, .gi-prob__cierre, .gi-packs--tarjetas .gi-packs__op--combo');
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => precios().forEach((el) => this.observador.observe(el)), { once: true });
        } else {
          precios().forEach((el) => this.observador.observe(el));
        }
      }
      disconnectedCallback() {
        this.observador?.disconnect();
        document.documentElement.removeAttribute('data-gi-cyb-vista');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-producto-precio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-elegir-skills')) {
    class GiElegirSkills extends HTMLElement {
      connectedCallback() {
        this.controlador = new AbortController();
        const { signal } = this.controlador;
        this.pct2 = Number(this.dataset.pctDos) || 0;
        this.pct4 = Number(this.dataset.pctCuatro) || 0;
        this.casillas = [...this.querySelectorAll('input[type="checkbox"]')];
        this.extras = this.querySelector('template[data-extras]')?.innerHTML || '';
        this.casillas.forEach((c) => c.addEventListener('change', () => this.actualizar(), { signal }));
        this.querySelectorAll('[data-destino]').forEach((b) =>
          b.addEventListener('click', () => this.comprar(b), { signal })
        );
        this.actualizar();
        window.giMoneda?.then(() => this.actualizar());
      }

      disconnectedCallback() {
        this.controlador?.abort();
      }

      plata(centavos) {
        return '$' + (centavos / 100).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      pctPara(cantidad) {
        if (cantidad >= 4) return this.pct4;
        if (cantidad >= 2) return this.pct2;
        return 0;
      }

      actualizar() {
        const elegidas = this.casillas.filter((c) => c.checked);
        const n = elegidas.length;
        const ahora = elegidas.reduce((t, c) => t + Number(c.dataset.precio), 0);
        const lista = elegidas.reduce((t, c) => t + Number(c.dataset.lista), 0);
        const pct = this.pctPara(n);
        const total = Math.round((ahora * (100 - pct)) / 100);
        const ahorro = lista - total;

        const lineas = elegidas
          .map((c) => {
            const precio = Number(c.dataset.precio);
            const lista = Number(c.dataset.lista);
            // Tachado solo si hay descuento real; si no, el precio normal.
            // Afuera de Argentina (gi-moneda) se cobra en dólares: la línea muestra el precio en USD.
            if (this.dataset.usd && document.documentElement.classList.contains('gi-usd')) {
              return `<li><span>${c.dataset.nombre}</span><strong>USD ${this.dataset.usd}</strong></li>`;
            }
            const monto = lista > precio ? `<s>${this.plata(lista)}</s>` : `<strong>${this.plata(precio)}</strong>`;
            return `<li><span>${c.dataset.nombre}</span>${monto}</li>`;
          })
          .join('');
        const oferta = lista > ahora
          ? `<li><span>Oferta de lanzamiento</span><strong class="gi-elegir__verde">−${Math.round(((lista - ahora) * 100) / lista)}%</strong></li>`
          : '';
        const cantidad = pct > 0
          ? `<li><span>Descuento por ${n} agentes</span><strong class="gi-elegir__verde">−${pct}%</strong></li>`
          : '';
        this.querySelector('[data-lineas]').innerHTML = n
          ? lineas + this.extras + oferta + cantidad
          : '<li><span>Elegí al menos un agente.</span></li>';

        const totalEl = this.querySelector('[data-total]');
        if (totalEl) totalEl.textContent = this.plata(total);
        // Las cuotas del total siguen al total del pedido.
        const cuota = this.querySelector('.gi-elegir__resumen .gi-cuotas strong');
        if (cuota) {
          cuota.textContent = this.plata(Math.round(total / 2));
          cuota.closest('.gi-cuotas').hidden = !n;
        }
        const ahorroEl = this.querySelector('[data-ahorro]');
        if (ahorroEl) {
          ahorroEl.hidden = !(n && ahorro > 0);
          ahorroEl.textContent = `Ahorrás ${this.plata(ahorro)} (${lista ? Math.round((ahorro * 100) / lista) : 0}%)`;
        }

        // Empujón al siguiente escalón de descuento.
        const progreso = this.querySelector('[data-progreso]');
        const todas = this.casillas.length;
        let texto = '';
        if (n === 1 && this.pct2 > 0) {
          texto = `Sumá 1 agente más y pagás <strong>${this.pct2}% menos</strong> en las dos.`;
        } else if (n >= 2 && n < todas && todas >= 4 && this.pct4 > this.pct2) {
          const faltan = todas - n;
          texto = `Sumá ${faltan === 1 ? 'la que falta' : 'las ' + faltan + ' que faltan'} y pagás <strong>${this.pct4}% menos</strong> en las ${todas}.`;
        } else if (n >= 4 && this.pct4 > 0) {
          texto = `Llevás los ${n} agentes con el mejor precio: <strong>${this.pct4}% menos</strong>.`;
        }
        if (progreso) progreso.innerHTML = texto;
      }

      async comprar(boton) {
        const ids = this.casillas.filter((c) => c.checked).map((c) => Number(c.value));
        const error = this.querySelector('.gi-elegir__error');
        if (!ids.length) {
          if (error) {
            error.textContent = 'Elegí al menos un agente.';
            error.hidden = false;
          }
          return;
        }
        if (error) error.hidden = true;
        this.querySelectorAll('[data-destino]').forEach((b) => b.setAttribute('aria-busy', 'true'));
        try {
          // Una licencia alcanza para todas las marcas: lo que ya está en el carrito no se suma otra vez.
          const carrito = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const enCarrito = new Set(carrito.items.map((item) => item.variant_id));
          const items = ids.filter((id) => !enCarrito.has(id)).map((id) => ({ id, quantity: 1 }));
          if (items.length) {
            const r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            if (!r.ok) throw new Error('No se pudo agregar');
          }
          window.location.href = boton.dataset.destino;
        } catch (e) {
          if (error) {
            error.textContent = 'No pudimos agregarlo al carrito. Probá de nuevo en unos segundos.';
            error.hidden = false;
          }
          this.querySelectorAll('[data-destino]').forEach((b) => b.removeAttribute('aria-busy'));
        }
      }
    }
    customElements.define('gi-elegir-skills', GiElegirSkills);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-testimonios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-tst-caida')) {
    // Las capturas caen según cuánto se bajó: cada una arranca un poco después que la anterior.
    // Sin JavaScript o con "reducir movimiento" quedan todas en su lugar (--p: 1).
    class GiTstCaida extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.seccion = this.closest('.gi-tst--caida') || this;
        this.mesa = this.querySelector('.gi-tst__mesa');
        this.caps = [...this.querySelectorAll('[data-cap]')];
        if (!this.caps.length) return;
        this.controlador = new AbortController();
        const { signal } = this.controlador;
        const pedir = () => {
          if (!this.cuadro) this.cuadro = requestAnimationFrame(() => {
            this.cuadro = 0;
            this.actualizar();
          });
        };
        // El tema no mueve la ventana sino un contenedor (.page-wrapper): se escucha cualquier scroll.
        document.addEventListener('scroll', pedir, { passive: true, capture: true, signal });
        window.addEventListener('resize', pedir, { signal });
        // Las imágenes se cargan antes de que caigan, así no aparecen vacías.
        this.caps.forEach((c) => c.querySelector('img')?.setAttribute('loading', 'eager'));
        this.actualizar();
      }

      disconnectedCallback() {
        this.controlador?.abort();
        cancelAnimationFrame(this.cuadro);
      }

      actualizar() {
        const vh = window.innerHeight;
        const mesa = this.mesa.getBoundingClientRect();
        this.caps.forEach((c) => {
          // Cada captura cae cuando su lugar (sin la animación) entra en pantalla.
          const arriba = mesa.top + c.offsetTop;
          const t = Math.max(0, Math.min(1, (vh * 0.95 - arriba) / (vh * 0.4)));
          // Cae rápido y se asienta con un pequeño rebote.
          const e = t >= 1 ? 1 : 1 - Math.pow(1 - t, 3) + Math.sin(t * Math.PI) * 0.04;
          c.style.setProperty('--p', e.toFixed(4));
        });
      }
    }
    customElements.define('gi-tst-caida', GiTstCaida);
  }

  if (!customElements.get('gi-tst-video')) {
    // El video corre sin sonido mientras se ve; el botón activa o corta el sonido.
    class GiTstVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.boton = this.querySelector('[data-sonido]');
        if (!this.video) return;
        this.controlador = new AbortController();
        this.boton?.addEventListener('click', () => this.alternar(), { signal: this.controlador.signal });
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observador = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) this.video.play().catch(() => {});
          else this.video.pause();
        }, { threshold: 0.3 });
        this.observador.observe(this);
      }

      disconnectedCallback() {
        this.controlador?.abort();
        this.observador?.disconnect();
      }

      alternar() {
        const sonando = !this.video.muted;
        this.video.muted = sonando;
        if (!sonando) {
          this.video.currentTime = 0;
          this.video.play().catch(() => {});
        }
        this.toggleAttribute('data-sonando', !sonando);
        this.boton?.setAttribute('aria-label', sonando ? 'Activar el sonido' : 'Quitar el sonido');
      }
    }
    customElements.define('gi-tst-video', GiTstVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-videos-abanico')) {
    const MAX = 7;
    const MITAD = 3;

    class GiVideosAbanico extends HTMLElement {
      connectedCallback() {
        this.controlador = new AbortController();
        const { signal } = this.controlador;
        this.cartas = [...this.querySelectorAll('[data-carta]')];
        this.total = this.cartas.length;
        this.pagina = this.total > MAX;
        this.centro = this.pagina ? MITAD : this.total >> 1;
        this.hover = null;
        this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.pagina) {
          const nav = this.querySelector('[data-nav]');
          const puntos = this.querySelector('[data-puntos]');
          nav.hidden = !this.hasAttribute('data-flechas');
          puntos.innerHTML = this.cartas.map(() => '<span></span>').join('');
          this.querySelectorAll('[data-mover]').forEach((b) =>
            b.addEventListener('click', () => {
              this.girar(Number(b.dataset.mover));
              this.esperar();
            }, { signal })
          );
          this.setAttribute('data-gira', '');
          this.arrastre(signal);
        }

        this.cartas.forEach((carta) => {
          // Solo con mouse: en el celu un toque no tiene que dejar el abanico frenado.
          carta.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse' || this.arrastrando) return;
            const slot = this.slotDe(carta);
            if (slot !== undefined && slot !== this.hover) {
              this.hover = slot;
              this.ubicar();
            }
          }, { signal });
          carta.querySelector('[data-play]')?.addEventListener('click', () => this.alternar(carta), { signal });
        });
        this.querySelector('[data-mazo]').addEventListener('mouseleave', () => {
          this.hover = null;
          this.ubicar();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.programar(), { signal });
        window.addEventListener('resize', () => this.ubicar(), { signal });

        // Entra cuando la sección aparece en pantalla, con las cartas de a una.
        this.entrada = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          this.entrada.disconnect();
          this.entro = true;
          this.ubicar(true);
        }, { threshold: 0.2 });
        this.entrada.observe(this);

        // El giro automático solo corre mientras la sección está en pantalla.
        this.enPantalla = new IntersectionObserver(([e]) => {
          this.visible = e.isIntersecting;
          this.programar();
        }, { threshold: 0.35 });
        this.enPantalla.observe(this);

        // Cada video corre sin sonido solo mientras se ve.
        this.observador = new IntersectionObserver((entradas) => {
          for (const e of entradas) {
            const v = e.target;
            if (e.isIntersecting && !this.reducido && !v.closest('[data-carta]').dataset.lado) v.play().catch(() => {});
            else if (!v.closest('[data-carta]').hasAttribute('data-sonando')) v.pause();
          }
        });
        this.cartas.forEach((c) => {
          const v = c.querySelector('video');
          if (v) this.observador.observe(v);
        });
      }

      disconnectedCallback() {
        this.controlador?.abort();
        this.entrada?.disconnect();
        this.observador?.disconnect();
        this.enPantalla?.disconnect();
        clearTimeout(this.reloj);
      }

      // Gira un lugar en sentido horario cada tantos segundos, salvo que algo lo frene.
      programar() {
        clearTimeout(this.reloj);
        const segundos = Number(this.dataset.giro || 0);
        if (!this.pagina || !segundos || this.reducido) return;
        this.reloj = setTimeout(() => {
          const frenado =
            !this.visible ||
            document.hidden ||
            this.hover !== null ||
            this.arrastrando ||
            this.cartas.some((c) => c.hasAttribute('data-sonando'));
          if (!frenado) this.girar(-1);
          this.programar();
        }, segundos * 1000);
      }

      // Después de que la persona lo mueve, espera un poco más antes de seguir solo.
      esperar() {
        clearTimeout(this.reloj);
        clearTimeout(this.pausa);
        this.pausa = setTimeout(() => this.programar(), 4000);
      }

      // Arrastrar a la derecha gira en sentido horario; a la izquierda, al revés.
      arrastre(signal) {
        const mazo = this.querySelector('[data-mazo]');
        let inicio = null;
        let movido = false;
        mazo.addEventListener('pointerdown', (e) => {
          if (e.button !== 0 || e.target.closest('[data-play]')) return;
          inicio = { x: e.clientX, y: e.clientY };
          movido = false;
        }, { signal });
        mazo.addEventListener('pointermove', (e) => {
          if (!inicio) return;
          const dx = e.clientX - inicio.x;
          if (!this.arrastrando && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - inicio.y)) {
            this.arrastrando = true;
            this.setAttribute('data-arrastrando', '');
          }
          if (!this.arrastrando) return;
          const paso = Math.max(50, this.cartas[0].offsetWidth * 0.45);
          if (Math.abs(dx) >= paso) {
            this.girar(dx > 0 ? -1 : 1);
            inicio.x = e.clientX;
            movido = true;
          }
        }, { signal });
        const soltar = () => {
          if (!inicio) return;
          inicio = null;
          if (this.arrastrando) {
            this.arrastrando = false;
            this.removeAttribute('data-arrastrando');
            this.esperar();
          }
        };
        mazo.addEventListener('pointerup', soltar, { signal });
        mazo.addEventListener('pointercancel', soltar, { signal });
        mazo.addEventListener('pointerleave', soltar, { signal });
        // Si arrastró, que el soltar no cuente como clic en el botón de sonido.
        mazo.addEventListener('click', (e) => {
          if (movido) {
            e.stopPropagation();
            e.preventDefault();
            movido = false;
          }
        }, { capture: true, signal });
        mazo.addEventListener('dragstart', (e) => e.preventDefault(), { signal });
      }

      // Cuánto se abre el abanico: lo que entra en el ancho disponible, sin pasarse del diseño original.
      multiplicador() {
        const mazo = this.querySelector('[data-mazo]');
        const carta = this.cartas[0];
        if (!mazo || !carta) return 1;
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        const libre = mazo.clientWidth / 2 - carta.offsetWidth * 0.85;
        // En el celular casi no hay lugar libre y el abanico quedaba cerrado, con las cartas de atrás
        // escondidas detrás de la del medio: ahí se abre igual y las de las puntas asoman por los costados.
        const minimo = mazo.clientWidth < 640 ? 0.36 : 0.2;
        return Math.max(minimo, Math.min(1, libre / (30 * rem)));
      }

      // Qué carta va en cada lugar del abanico (con más de 7, solo se ven 7 alrededor del centro).
      visibles() {
        const mapa = new Map();
        if (!this.pagina) {
          this.cartas.forEach((c, i) => mapa.set(i, i));
          return mapa;
        }
        for (let s = 0; s < MAX; s++) mapa.set((((this.centro + s - MITAD) % this.total) + this.total) % this.total, s);
        return mapa;
      }

      slotDe(carta) {
        return this.visibles().get(this.cartas.indexOf(carta));
      }

      // Giro, escala, desplazamiento (rem) y capa de cada lugar.
      config(slot) {
        const n = this.pagina ? MAX : this.total;
        const c = (n - 1) / 2;
        const d = c > 0 ? (slot - c) / c : 0;
        const a = Math.abs(d);
        return { rot: d * 21, scale: 1 - 0.2244 * a * a, x: d * 30, y: a * a * 7.3, z: 10 - Math.round(Math.abs(slot - c)) };
      }

      ubicar(primera = false) {
        if (!this.entro) return;
        const m = this.multiplicador();
        const mapa = this.visibles();
        const n = this.pagina ? MAX : this.total;
        const c = (n - 1) / 2;
        this.cartas.forEach((carta, i) => {
          const slot = mapa.get(i);
          if (slot === undefined) {
            // Las que no entran esperan fuera del abanico: la que sale se va por la derecha y la
            // que va a entrar espera a la izquierda. Al cambiar de lado salta sin animación.
            const desde = (((i - this.centro) % this.total) + this.total) % this.total;
            const lado = desde <= this.total / 2 ? 'der' : 'izq';
            const fuera = this.config(lado === 'der' ? MAX : -1);
            const salta = carta.dataset.lado && carta.dataset.lado !== lado;
            carta.dataset.lado = lado;
            carta.style.transition = salta ? 'none' : '';
            carta.style.opacity = '0';
            carta.style.zIndex = '0';
            carta.style.transform = `translate(${fuera.x * m}rem, ${fuera.y}rem) rotate(${fuera.rot}deg) scale(${fuera.scale * 0.9})`;
            carta.style.pointerEvents = 'none';
            const oculto = carta.querySelector('video');
            if (oculto && !carta.hasAttribute('data-sonando')) oculto.pause();
            return;
          }
          // La que vuelve a entrar arranca su video si la sección está a la vista.
          if (carta.dataset.lado && this.visible && !this.reducido) carta.querySelector('video')?.play().catch(() => {});
          delete carta.dataset.lado;
          carta.style.transition = '';
          const b = this.config(slot);
          let x = b.x * m;
          let y = b.y;
          let rot = b.rot;
          let scale = b.scale;
          let delay = 0;
          if (this.hover !== null) {
            const dist = Math.abs(slot - this.hover);
            delay = dist * 0.02;
            if (slot === this.hover) {
              y -= 2.5;
              scale *= 1.08;
            } else {
              const lado = slot < this.hover ? -1 : 1;
              x += lado * (6 + 4 / dist) * m;
              rot += lado * (3 / (dist + 1));
            }
          } else if (primera) {
            delay = 0.15 + slot * 0.07;
          } else {
            delay = Math.abs(slot - c) * 0.02;
          }
          carta.style.pointerEvents = '';
          carta.style.zIndex = String(slot === this.hover ? 20 : b.z);
          carta.style.transitionDelay = this.reducido ? '0s' : `${delay}s`;
          carta.style.opacity = '1';
          carta.style.transform = `translate(${x}rem, ${y}rem) rotate(${rot}deg) scale(${scale})`;
        });
        this.querySelectorAll('[data-puntos] span').forEach((p, i) => p.toggleAttribute('data-activo', i === this.centro));
      }

      girar(dir) {
        this.centro = (this.centro + dir + this.total) % this.total;
        this.hover = null;
        this.ubicar();
      }

      alternar(carta) {
        const v = carta.querySelector('video');
        if (!v) return;
        const boton = carta.querySelector('[data-play]');
        if (carta.hasAttribute('data-sonando')) {
          v.muted = true;
          carta.removeAttribute('data-sonando');
          boton?.setAttribute('aria-label', 'Reproducir con sonido');
          return;
        }
        this.cartas.forEach((o) => {
          if (o === carta || !o.hasAttribute('data-sonando')) return;
          o.removeAttribute('data-sonando');
          o.querySelector('[data-play]')?.setAttribute('aria-label', 'Reproducir con sonido');
          const ov = o.querySelector('video');
          if (ov) ov.muted = true;
        });
        v.muted = false;
        v.play().catch(() => {});
        carta.setAttribute('data-sonando', '');
        boton?.setAttribute('aria-label', 'Quitar el sonido');
      }
    }
    customElements.define('gi-videos-abanico', GiVideosAbanico);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-visitas-hoy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gi-visitas-hoy')) {
    class GiVisitasHoy extends HTMLElement {
      connectedCallback() {
        const producto = this.dataset.producto;
        const hoy = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Argentina/Buenos_Aires' });
        const clave = `gi-vh-cerrado:${producto}`;
        let cerrado = null;
        try {
          cerrado = localStorage.getItem(clave);
        } catch (e) {}
        if (!producto || cerrado === hoy) return;
        this.querySelector('[data-cerrar]')?.addEventListener('click', () => {
          this.classList.remove('is-visible');
          setTimeout(() => (this.hidden = true), 400);
          try {
            localStorage.setItem(clave, hoy);
          } catch (e) {}
        });
        const mostrar = (n, unidad) => {
          if (!n || n < Number(this.dataset.minimo || 1)) return;
          this.querySelector('[data-numero]').textContent = n.toLocaleString('es-AR') + ' ' + unidad;
          setTimeout(() => {
            this.hidden = false;
            requestAnimationFrame(() => this.classList.add('is-visible'));
          }, Number(this.dataset.espera || 0) * 1000);
        };
        if (this.dataset.modo === 'shopify30') {
          fetch('https://panel.generarimpacto.com/api/publico/visitas-tienda')
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
              const n = Number(d && d.visitas);
              mostrar(n, n === 1 ? 'visita' : 'visitas');
            })
            .catch(() => {});
          return;
        }
        const sitio = this.dataset.modo !== 'producto';
        let cuerpo = { producto };
        if (sitio) {
          // La misma sesión que anota gi-sesiones: así esta visita no suma dos veces.
          let id = null;
          try {
            id = sessionStorage.getItem('gi-sesion');
            if (!id) {
              id = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2, 12);
              sessionStorage.setItem('gi-sesion', id);
            }
          } catch (e) {}
          if (!id) return;
          cuerpo = { sesion: id };
        }
        fetch('https://skills.generarimpacto.com/api/visitas', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cuerpo),
        })
          .then((r) => (r.ok ? r.json() : null))
          .then((d) => {
            const n = Number(d && (this.dataset.modo === 'total' ? d.total : d.hoy));
            mostrar(n, sitio ? (n === 1 ? 'visita' : 'visitas') : n === 1 ? 'persona' : 'personas');
          })
          .catch(() => {});
      }
    }
    customElements.define('gi-visitas-hoy', GiVisitasHoy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gi-vuelve"]) return;
  try {
    
  if (!customElements.get('gi-vuelve')) {
    class GiVuelve extends HTMLElement {
      connectedCallback() {
        const CLAVE = 'gi-checkout';
        const VISTO = 'gi-vuelve-visto';
        const leer = (s, k) => {
          try {
            return JSON.parse(s.getItem(k) || 'null');
          } catch (e) {
            return null;
          }
        };
        const guardar = (s, k, v) => {
          try {
            s.setItem(k, JSON.stringify(v));
          } catch (e) {}
        };
        // 1) Anota cuando la persona va al checkout de Shopify (los links /cart/... y /checkouts/...).
        document.addEventListener(
          'click',
          (e) => {
            const a = e.target.closest('a[href]');
            if (!a) return;
            let url;
            try {
              url = new URL(a.href, location.href);
            } catch (err) {
              return;
            }
            // En USD el pago es en la plataforma (skills.generarimpacto.com): se anota el link completo.
            if (url.host === 'skills.generarimpacto.com' && url.pathname === '/api/comprar') {
              if (!this.dataset.usd || url.searchParams.get('producto') !== 'editor-reels-usd') return;
              guardar(localStorage, CLAVE, { usd: true, href: url.href, t: Date.now() });
              return;
            }
            if (url.host !== location.host) return;
            if (!/^\/(cart\/\d|checkouts?\/)/.test(url.pathname)) return;
            guardar(localStorage, CLAVE, { href: url.pathname + url.search, t: Date.now() });
          },
          true
        );
        // 2) Al volver a la tienda, si fue al checkout hace poco, ofrece el descuento una sola vez.
        const revisar = () => {
          const ida = leer(localStorage, CLAVE);
          if (!ida) return;
          // Si viene de la página de gracias, ya compró.
          if (/thank[-_]you|\/orders\//.test(document.referrer)) {
            localStorage.removeItem(CLAVE);
            return;
          }
          const minutos = Number(this.dataset.minutos) || 120;
          if (Date.now() - ida.t > minutos * 60000) {
            localStorage.removeItem(CLAVE);
            return;
          }
          const visto = leer(localStorage, VISTO);
          const dias = Number(this.dataset.dias) || 3;
          if (visto && Date.now() - visto < dias * 86400000) return;
          localStorage.removeItem(CLAVE);
          guardar(localStorage, VISTO, Date.now());
          if (ida.usd) {
            // En USD el 5% es otro producto de la plataforma (editor-reels-usd-vuelve, USD 44,65).
            const u = new URL(ida.href);
            u.searchParams.set('producto', this.dataset.usd || 'editor-reels-usd-vuelve');
            this.querySelector('[data-ir]').href = u.href;
            setTimeout(() => this.querySelector('dialog')?.showModal(), 500);
            return;
          }
          const codigo = this.dataset.codigo;
          const [ruta, query = ''] = ida.href.split('?');
          const params = new URLSearchParams(query);
          const actual = params.get('discount');
          params.set('discount', actual ? `${actual},${codigo}` : codigo);
          this.querySelector('[data-ir]').href = `${ruta}?${params.toString().replace(/%2C/g, ',')}`;
          setTimeout(() => this.querySelector('dialog')?.showModal(), 500);
        };
        this.querySelectorAll('[data-cerrar]').forEach((b) => b.addEventListener('click', () => this.querySelector('dialog').close()));
        this.querySelector('dialog')?.addEventListener('click', (e) => {
          if (e.target.tagName === 'DIALOG') e.target.close();
        });
        // pageshow también corre cuando se vuelve con la flecha de atrás (página guardada en memoria).
        window.addEventListener('pageshow', revisar);
        if (document.readyState === 'complete') revisar();
      }
    }
    customElements.define('gi-vuelve', GiVuelve);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
